import { ApiNames } from 'components/Common/ApiManagement/apiServices';
import axiosInstance from 'components/Common/ApiManagement/axiosInstance';
import { USERTYPES } from 'components/Common/Constant';
import { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, DropdownMenu, DropdownToggle, Dropdown, DropdownItem } from 'reactstrap';

const EditModal = ({ modal, setModal, handleSubmit, setEditUserData, editUserData, isModifying }) => {
      const [suggestions, setSuggestions] = useState([]);
      const [dropdownOpen, setDropdownOpen] = useState(false);
      const [orgInputValue, setOrgInputValue] = useState("");
      const [organizationId, setOrganizationId] = useState("");
        const [addOrgButton, setAddOrgButton] = useState(false);
      const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

      const handleRadioClick = (e) => {
        setEditUserData((prev) => ({
            ...prev,
            userType: e.target.value
        }));
    }

    const handleInputChange = (e) => {
        setEditUserData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

      const fetchSuggestions = async (query) => {
        if (!query) {
          setSuggestions([]);
          return;
        }
        try {
          const { data } = await axiosInstance.get(`${ApiNames.LIST_ORGANIZATION}?search=${query}`)
          setSuggestions(data.data);
          setDropdownOpen(data.data.length > 0)
          setAddOrgButton(query.length > 2 && !data.data.length > 0)
        } catch (error) {
        //   handleErrors(error)
        }
      };
      const handleOrgInputChange = e => {
        const value = e.target.value;
        setOrgInputValue(value);
        setEditUserData((prev) => ({
            ...prev,
            branch: e.target.value
        }));
        fetchSuggestions(value);
      };

      const handleSelect = org => {
        setOrgInputValue(org.branch);
        setOrganizationId(org._id);
        setSuggestions([]);
        setDropdownOpen(false);
        setEditUserData((prev) => ({
            ...prev,
            org_id: org._id
        }));
      };

    const toggle = () => setModal(!modal)

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Enter New Details</ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <FormGroup>
                        <Label for="firstname">First Name</Label>
                        <Input
                            type="text"
                            name="firstname"
                            id="firstname"
                            placeholder="Enter firstname"
                            value={editUserData?.firstname || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="lastname">Last Name</Label>
                        <Input
                            type="text"
                            name="lastname"
                            id="lastname"
                            placeholder="Enter lastname"
                            value={editUserData?.lastname || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter email"
                            value={editUserData?.email || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    {/* <FormGroup>
                        <Label for="phone">Phone Number</Label>
                        <Input
                            type="number"
                            name="phoneNumber"
                            id="phone"
                            placeholder="Enter phone number"
                            value={editUserData?.phoneNumber || ''}
                            onChange={handleInputChange}
                        />
                    </FormGroup> */}
                        <Label for="Organization">Organization</Label>

           <Dropdown isOpen={dropdownOpen} aria-autocomplete='off' toggle={toggleDropdown}>
                        <DropdownToggle tag="div" className="w-100">
                          <div className="mb-3 position-relative">
                            <Input
                              name="organization"
                              type="text"
                              className="form-control py-2"
                              placeholder="Choose or create organization"
                              autoComplete='off'
                              onChange={handleOrgInputChange}
                              value={orgInputValue || editUserData.branch || ""}
                          
                            />
                            {/* {addOrgButton && (
                              <button
                                className="position-absolute btn btn-primary waves-effect waves-light"
                                style={{
                                  top: '13%',
                                  right: '1.5%',
                                  padding: '3px 10px'
                                }}
                                onClick={(e) => {
                                  e.preventDefault()
                                  
                                }}
                              >
                                <i className="mdi mdi-plus fw-bold font-size-17 text-center"></i>
                              </button>
                            )} */}

                          </div>
                        </DropdownToggle>
                        {suggestions.length > 0 && (
                          <DropdownMenu className="w-100">
                            {suggestions.map((org, index) => (
                              <DropdownItem key={index} onClick={() => handleSelect(org)}>
                                {org.branch}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        )}
                      </Dropdown>







                    <FormGroup tag="fieldset" className='flex-col md:flex-row' style={{
                        display: 'flex',
                        justifyContent: 'start',
                        marginTop: '2em',
                        gap: '2em'
                    }}
                    >
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="radioOptions"
                                    value={USERTYPES.Standard}
                                    checked={editUserData?.userType === USERTYPES.Standard}
                                    onClick={handleRadioClick}
                                />{' '}
                                Standard
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="radioOptions"
                                    value={USERTYPES.Organization}
                                    checked={editUserData?.userType === USERTYPES.Organization}
                                    onClick={handleRadioClick}
                                />{' '}
                                Organization Admin
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="radioOptions"
                                    value={USERTYPES.Global}
                                    checked={editUserData?.userType === USERTYPES.Global}
                                    onClick={handleRadioClick}
                                />{' '}
                                Global Admin
                            </Label>
                        </FormGroup>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={isModifying} color="primary" type="submit">Submit</Button>{' '}
                    <Button disabled={isModifying} color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}

export default EditModal